import {instanceAxios} from "@/axios/axios";
import cookie from "js-cookie";

export default function changePhone(newPhone) {
    return new Promise((resolve, reject) => {
        instanceAxios
            .post(
                'change-phone',
                {
                    params: {
                        userToken: cookie.get('token')
                    },
                    values: newPhone
                }
            )
            .then((response) => {
                resolve(response)
            })
            .catch((error) => {
                return reject(error)
            })
    })
}